/*eslint-disable*/ export const messages = JSON.parse("{\"textarea.label.optional\":[\"Valfritt\"]}");
//# sourceMappingURL=messages.mjs.map